<template>
  <b-form>
    <b-form-row class="mb-2">
      <b-col class="d-flex align-items-center">
        <h4>Документы</h4>
      </b-col>
      <b-col class="col-4">
        <b-form-input size="sm" type="date" v-model="date"/>
      </b-col>
      <b-col class="col-3"/>
    </b-form-row>
    <b-form-row class="mb-2">
      <b-table
        class="align-items-center text-nowrap"
        responsive
        :striped="false"
        :no-border-collapse="true"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :small="small"
        :hover="hover"
        :dark="dark"
        :fixed="fixed"
        :foot-clone="footClone"
        :items="items"
        :fields="fields"
        :head-variant="headVariant"
        :table-variant="tableVariant"
        :filter="filter"
        :sort-by="'created_at'"
        :sort-desc="true"
      >
        <template #head(created_at)>
          <div class="text-nowrap">Дата</div>
        </template>
        <template #head(type)>
          <div class="text-nowrap">Тип</div>
        </template>
        <template #head(filename)>
          <div class="text-nowrap">Имя документа</div>
        </template>
        <template #head(status)>
          <div class="text-nowrap">Статус</div>
        </template>
        <template #head(amount)>
          <div class="text-nowrap">Сумма платежа</div>
        </template>
        <template #head(download)>
          <div class="text-nowrap">Скачать</div>
        </template>
        <template #head(delete)>
          <div class="text-nowrap">Удалить</div>
        </template>

        <template #cell(type)="row">
          <b-button
            pill
            :variant="row.item.type ? type_color[row.item.type] : 'dark'"
            size="sm"
            class="mr-8"
          >
            {{ row.item.type }}
          </b-button>
        </template>

        <template #cell(status)="row">
          <b-button
            pill
            :variant="row.item.status ? status_color[row.item.status] : 'dark'"
            size="sm"
            class="mr-8"
          >
            {{ row.item.status }}
          </b-button>
        </template>

        <template #cell(download)="row">
          <b-button variant="link" @click="downloadFile(row.item)"
            ><i class="ri-file-download-line remix-icon"></i
          ></b-button>
        </template>

        <template #cell(delete)="row">
          <b-button variant="link" @click="deleteDoc(row.item)"
            ><i class="ri-delete-bin-line remix-icon"></i
          ></b-button>
        </template>
      </b-table>
    </b-form-row>

    <b-row>
      <b-col>
        <b-row class="align-items-center ml-0">
          <span class="hp-placeholder mr-2">Строк на страницу</span>
          <b-form-select size="sm" class="col-3 float-left" v-model="perPage">
            <b-form-select-option :value="10">10</b-form-select-option>
            <b-form-select-option :value="50">50</b-form-select-option>
            <b-form-select-option :value="100">100</b-form-select-option>
            <b-form-select-option :value="200">200</b-form-select-option>
          </b-form-select>
        </b-row>
      </b-col>
      <b-col
        ><b-pagination
          class="float-right"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          size="sm"
        ></b-pagination
      ></b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BTable,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
  BFormCheckbox,
  BFormSelect,
  BInputGroup,
  BButton,
  BFormInput,
  BInputGroupAppend,
  BFormDatepicker,
  BFormRow,
  BCol,
  BRow,
  BPagination,
  BDropdown,
  BDropdownItem,
  BFormSelectOption,
  BCard,
  BLink,
} from "bootstrap-vue";

import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      status_color: {
        "Оплачено": "outline-success",
        "Не оплачено": "outline-danger",
        "Просмотрено": "outline-primary",
        "Не просмотрено": "outline-dark",
      },

      type_color: {
        Счет: "outline-success",
        Отчет: "outline-primary",
      },

      fields: [""],
      items: [""],
      striped: false,
      bordered: false,
      borderless: false,
      outlined: false,
      small: false,
      hover: false,
      dark: false,
      fixed: false,
      footClone: false,
      headVariant: null,
      tableVariant: "",
      noCollapse: false,
      filter: "",
      date: "",

      currentPage: 1,
      perPage: 10,
      rows: 0,
    };
  },
  components: {
    BCol,
    BRow,
    BTable,
    BForm,
    BFormGroup,
    BFormRadioGroup,
    BFormRadio,
    BFormCheckbox,
    BFormSelect,
    BInputGroup,
    BButton,
    BFormInput,
    BInputGroupAppend,
    BFormDatepicker,
    BFormRow,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelectOption,
    BCard,
    BLink,
  },

  methods: {
    async updateTable() {
      var inn = this.$route.params.inn;
      if (!inn) {
        inn = this.$store.state.user["inn"];
      }

      const { data } = await axios.get(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/documents/${inn}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(data);

      this.fields = [
        { key: "created_at", sortable: true },
        { key: "type", sortable: true },
        { key: "filename", sortable: true },
        { key: "status", sortable: true },
        { key: "amount", sortable: true },
        { key: "download", sortable: false },
        { key: "delete", sortable: false },
      ];
      this.items = data.items;
      this.items.forEach(el => {
        try {
          el.created_at && (el.created_at = moment(el.created_at, 'YYYY-MM-DD HH24:mm:SS').format('YYYY-MM-DD HH:mm'));
        } catch (e) {
          console.warn(`Can't format date-time (${el.created_at}) for document table`, e);
        }
      });
      this.rows = this.items.length;
    },
    downloadFile(item) {
      axios({
        url: `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/documents/${item.inn}/download/${item.id}`,
        method: "GET",
        responseType: "blob",
      }).then(function (response) {
          const href = window.URL.createObjectURL(response.data);

          const anchorElement = document.createElement("a");

          anchorElement.href = href;
          anchorElement.download = `${item.filename}.pdf`;

          document.body.appendChild(anchorElement);
          anchorElement.click();

          document.body.removeChild(anchorElement);
          window.URL.revokeObjectURL(href);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async deleteDoc(item) {
      await axios({
        url: `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/documents/${item.inn}/delete/${item.id}`,
        method: "DELETE",
      });
      await this.updateTable();
    },
  },
  mounted() {
    this.updateTable();
  },
};
</script>
